import(/* webpackMode: "eager" */ "/app/src/app/[locale]/trends/page.tsx");
